export default "__VITE_ASSET__ZvwcOI2H__"